import React from 'react';
import Login from './login/Login';
import Otp from './otp/Otp';
import ChangePassword from './change-password/ChangePassword';
import EmailSent from './email-sent/EmailSent';
import ForgotPassword from './forgot-password/ForgotPassword';

const SECURITY_PAGES = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/otp',
    element: <Otp />,
  },
  {
    path: '/change-password',
    element: <ChangePassword />,
  },
  {
    path: '/email-sent',
    element: <EmailSent />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
];

export default SECURITY_PAGES;
